module.exports = __webpack_public_path__ + "img/ch7pic6.6ac7e088.png";